import { shorten } from './string';
export const DEBANK_TEAM_ADDRESS = '0x9b5e18bdcf64fd2e26c9a0b043ef2049cb9aad2c';
const DEBANK_ACCOUNT_NAME = 'No-reply';

export const CHATGPT_HI_ID = '0a110107';

export const OFFICIAL_ACCOUNT_HI_ID_PREFIX = '0a';
export const SYSTEM_ACCOUNT_HI_ID_PREFIX = '0b';

export function getUserNameByUserInfo(user?: UserInfo | null, noComment: boolean = false) {
  const desc = user?.desc;
  if (desc?.id === DEBANK_TEAM_ADDRESS) {
    return DEBANK_ACCOUNT_NAME;
  }
  if (desc?.user?.is_suicide) {
    return shorten(desc?.id || '', 6, 4).toLowerCase();
  }
  return (
    desc?.user?.web3_id ||
    (noComment ? '' : desc?.user?.memo) ||
    shorten(desc?.id || '', 6, 4).toLowerCase()
  );
}

export function getSpecialAvatarUrlByAddress(addr?: string) {
  if (addr === DEBANK_TEAM_ADDRESS) {
    return 'https://static.debank.com/image/user/org_avatar/0x5853ed4f26a3fcea565b3fbc698bb19cdf6deb85/7f462077b5eca430ea6bc68117013887.png';
  }
  return '';
}

// 这里为了兼容以后的 official account
export function getIsOfficialAccountById(userId: string): boolean {
  return !!userId && userId.length >= 8 && userId.startsWith(OFFICIAL_ACCOUNT_HI_ID_PREFIX);
}
export function convertOfficialIdToHiId(officialId: string): string {
  return officialId ? `${OFFICIAL_ACCOUNT_HI_ID_PREFIX}${officialId}` : '';
}

export function alignSystemAccountId(id = '') {
  return `${id}`.startsWith(SYSTEM_ACCOUNT_HI_ID_PREFIX)
    ? id
    : `${SYSTEM_ACCOUNT_HI_ID_PREFIX}${id}`;
}

export function convertOfficialHiIdToOriginalId(hiId: string = ''): string {
  return hiId?.startsWith('0a') ? hiId.slice(2) : hiId;
}
export function addPrefixToOfficialId(id: string = ''): string {
  return id?.startsWith('0a') ? id : `0a${id}`;
}

export function isContractByUserDesc(data?: UserDesc) {
  return Boolean(
    Object.values(data?.protocol || {}).length + Object.values(data?.contract || {}).length > 0,
  );
}
export function isMultisigContractByUserDesc(data?: UserDesc) {
  return Boolean(Object.values(data?.contract || {}).find(item => item.multisig));
}
export function isSybilByUserDesc(data?: UserDesc) {
  return data?.is_spam || data?.is_scam;
}

export const isCexAddress = (data?: UserDesc) => {
  return (
    !!data?.cex?.id &&
    (data.cex.is_deposit ||
      data.cex.is_vault ||
      data.cex.is_withdraw ||
      data.cex.is_collect ||
      data.cex.is_gastopup)
  );
};
